export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjNiNGZiNDM3LTEzYTAtNDY2Yy05OTRlLTg5YTVkZmYwMzM1NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.Af8bp9otlY8Vq2PLCiJPcJzxBHIf7pnj50FvyZnJGIE9oMKTfadZMLl9ziEy6HJJJCy4XTMBr5RVVku5MXmGkJ3zIh1RxtWgOh+QRmP2v+C/ThyTZvTHdGZuiw6XGYm2c0QrXg==';
